module.exports = __webpack_public_path__ + "img/dashed-connection.40caee34.png";